<template>
  <div ref="textContainer" :style="componentStyle">
    {{ conf.preText + formatTime + conf.sufText }}
  </div>
</template>

<script>
import eventbus from "../../../utils/eventbus";
import store from "../../../store";

export default {
  name: "TumengTime",
  components: {},
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing: false,
      // 这个防抖用 16ms只能调用一次
      time: Number.MIN_SAFE_INTEGER,
      Year: "",
      Month: "",
      Date: "",
      Hour: "",
      Minute: "",
      Second: "",
      formatTime: "",
    };
  },
  computed: {
    componentStyle() {
      return {
        width: this.conf.width + "px",
        height: this.conf.height + "px",
        position: "relative",
        top: 0,
        userSelect: "none",
        display: "flex",
        justifyContent: this.conf.textAlign,
        alignItems: this.conf.verticalAlign,
        lineHeight: this.conf.lineHeight,
        fontSize: this.conf.fontSize + "px",
        color: this.conf.fontColor,
        background: this.conf.bgColor,
        fontWeight: this.conf.isBold ? "bold" : "normal",
        fontStyle: this.conf.isItaly ? "italic" : "normal",
        textDecoration: this.conf.isUnderline,
        fontFamily: `'${this.conf.font}'`,
        whiteSpace: "nowrap",
        overflow: "hidden",
      };
    },
    taStyle() {
      return {
        height: this.conf.height + "px",
        fontSize: "24px",
      };
    },
    isShowHorizontal() {
      return (
        this.conf.scrollDirection === "left" ||
        this.conf.scrollDirection === "right"
      );
    },
  },
  watch: {
    "conf.text"() {
      // this.conf.text = this.conf.text;
    },
    conf: {
      handler() {
        console.log(this.conf.text);
        const confDate = new Date(this.conf.text);
        console.log(confDate);
        const padZero = (num) => num.toString().padStart(2, "0");
        this.Year = confDate.getFullYear();
        this.Month = padZero(confDate.getMonth() + 1);
        this.Date = padZero(confDate.getDate());
        this.Hour = padZero(confDate.getHours());
        this.Minute = padZero(confDate.getMinutes());
        this.Second = padZero(confDate.getSeconds());
        //  完整字符串格式：2023-08-20 14:05:30
        let dateSplice = ""; // 日期拼接字符串
        switch (this.conf.dateFormat) {
          case 1: // YYMMDD
            dateSplice = `${this.Year}${this.conf.dateSeparator}${this.Month}${this.conf.dateSeparator}${this.Date}`;
            break;
          case 2: // MMDDYY
            dateSplice = `${this.Month}${this.conf.dateSeparator}${this.Date}${this.conf.dateSeparator}${this.Year}`;
            break;
          case 3: // DDMMYY
            dateSplice = `${this.Date}${this.conf.dateSeparator}${this.Month}${this.conf.dateSeparator}${this.Year}`;
            break;
          default:
            dateSplice = `${this.Year}${this.conf.dateSeparator}${this.Month}${this.conf.dateSeparator}${this.Date}`;
        }

        let timeSplice = ""; // 时间拼接字符串
        switch (this.conf.timeFormat) {
          case 0: // None
            timeSplice = '';
            break;
          case 1: // 12H
            timeSplice = ` ${this.Hour>12?padZero(this.Hour - 12):this.Hour}${this.conf.timeSeparator}${this.Minute}${this.conf.timeSeparator}${this.Second}`;
            break;
          case 2: // 24H
            timeSplice = ` ${this.Hour}${this.conf.timeSeparator}${this.Minute}${this.conf.timeSeparator}${this.Second}`;
            break;
          default:
            timeSplice = ''
        }
        this.formatTime = `${dateSplice}${timeSplice}`;
      },
      deep: true,
      immediate: true,
    },
  },
  filters: {
    htmlFix(html) {
      return html
        .replace(/#line#/g, "\n")
        .replace(/#mark#/g, "'")
        .replace(/#marks#/g, '"');
    },
  },
  created() {
    eventbus.$on("click-component", (id) => {
      if (this.editing && id === this.conf.id) {
        // this.$refs.ta.focus()
      }
    });
    this.$once("beforeDestroy", () => {
      eventbus.$off("click-component");
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.oneline {
  word-break: keep-all;
  white-space: nowrap;
  display: flex;
}

.el-textarea {
  ::v-deep .el-textarea__inner {
    height: 100%;
  }
}
</style>
